import {useNavigate} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {Alert, Box, Button, Container, Grid, Link, Stack, TextField, Typography} from "@mui/material";
import GoogleIcon from '../icons/Google';
import useAuth from "../hooks/useAuth";
import {
  addDataProductUsersToCache,
  addDataProductUserToCache,
  createProductUserMutation,
  getProductUserQuery
} from "../gql/productUserGql";
import {executeMutationUtil, executeQueryUtil} from "../utils/gqlUtil";
import {useEffect, useState} from "react";
import localStrings from "../localStrings";
import {useFormik} from "formik";
import * as Yup from 'yup';
import {LoadingButton} from "@mui/lab";
import toast from "react-hot-toast";
import { getTempBrandUserByEmailQuery } from '../gql/tempBrandUserGql';

export async function fillUserContext(user, setAuthenticated, setEmailVerified, setContextDbUser, toggleProcessUserInDb) {
  try {
    if (!user) {
      return;
    }
    const userActive =
      {
        id: user.user.uid,
        email: user.user.email,
        displayName: user.user.displayName,
        mainUser: true,
      }
    //await executeQueryUtil(getProductUsersByBrandIdQuery(user.user.uid))

    let productUser = await executeQueryUtil(getProductUserQuery(user.user.uid));
    if (!productUser.data.getProductUser) {
      let resUserCreate = await executeMutationUtil(createProductUserMutation(user.user.uid, userActive));
      await addDataProductUsersToCache([resUserCreate?.data?.addProductUser]);
      await addDataProductUserToCache(resUserCreate?.data?.addProductUser);
    }
    await setAuthenticated(true);
    await setEmailVerified(user.user.emailVerified);
    await setContextDbUser(userActive);
    if (toggleProcessUserInDb) {
      await toggleProcessUserInDb();
    }
  }
  catch (err) {
    console.error(err);
  }
}

const Login = () => {
  const query = new URLSearchParams(window.location.search);
  const verificationCodeParam = query.get('verificationCode');
  const userMail = query.get('userMail');
  //const [logging, setLogging] = useState(false);
  const navigate = useNavigate();
  const { signInWithGoogle, setAuthenticated, isAuthenticated, setContextDbUser, emailVerified,
    signInWithEmailAndPasswordContext, setEmailVerified, currentBrand, toggleProcessUserInDb,
    logging, setLogging, brand, userInDb} = useAuth();

  const [errorDisplay, setErrorDisplay] = useState(null);
  const [warningDisplay, setWarningDisplay] = useState(null);

  async function loginSubmit(values) {
    try {
      setLogging(true);
      const user = await signInWithEmailAndPasswordContext(values.email, values.password)
      await fillUserContext(user, setAuthenticated, setEmailVerified, setContextDbUser, toggleProcessUserInDb)
    }
    catch (err) {
      //toast.error(err.code)
      // alert(err);
      // alert(err.code);
      // alert(err.code == "auth/user-not-found");
      if (err.code == "auth/wrong-password") {
        //toast.error(localStrings.warningMessage.wrongUserCredentials)
        //alert(err.code);
        setErrorDisplay(localStrings.warningMessage.wrongUserCredentials)
      }
      else if (err.code == "auth/user-not-found") {
        //toast.error(localStrings.warningMessage.unknownUser)
        //alert(localStrings.warningMessage.unknownUser);
        setErrorDisplay(localStrings.warningMessage.unknownUser)
      }

      else {
        setErrorDisplay(err.message)
      }
      console.log(err)
    }
    finally {
      setLogging(false);
    }

  }

  const formik = useFormik({
    initialValues: {
      email: userMail || '',
      password: ''
    },
    validationSchema: Yup.object({
      email: Yup
        .string()
        .email('Must be a valid email')
        .max(255)
        .required('Email is required'),
      password: Yup
        .string()
        .max(255)
        .required('Password is required')
    }),
    onSubmit: loginSubmit
  });



  useEffect(() => {
      const loadPage = async () => {
        if (isAuthenticated && emailVerified) {
          let resUser = await executeQueryUtil(getTempBrandUserByEmailQuery(userInDb.email));
          let tempBrandUser = resUser?.data?.getTempBrandUserByEmail;
          //alert(JSON.stringify(currentBrand() || {}))
          if (currentBrand()) {
            navigate('/dashboard', { replace: true });
          }
          else if (!tempBrandUser && userInDb && !userInDb.brandId){
            navigate('/dashboard/account', { replace: true });
          }
        }
        if (isAuthenticated && !emailVerified) {
          setWarningDisplay(localStrings.warningMessage.pleaseValidateYourAccount)
        }
      }
      loadPage()


    },
    [isAuthenticated, emailVerified, brand, userInDb, currentBrand()]);

  async function handleGoogleClick() {
    try {
      setLogging(true);
      var user = await signInWithGoogle();
      await fillUserContext(user, setAuthenticated, setEmailVerified, setContextDbUser)
      setLogging(false);
    } catch(err) {
      console.error(err);
    }

  }

  return (
    <div>

      {/*<p>{userMail}</p>*/}
      <Helmet>
        <title>{localStrings.login}</title>
      </Helmet>

      <Box
        component="main"
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexGrow: 1,
          minHeight: '100%'
        }}
      >
        <Container maxWidth="sm">

          {(errorDisplay || warningDisplay)&&
            <Stack sx={{width: '100%', marginTop: 5}} spacing={2}>
              {errorDisplay &&
                // <Alert severity="error">{localStrings.formatString(localStrings.loginError,  errorDisplay)}</Alert>
                <Alert severity="error">{localStrings.loginErrorBadCredentail}</Alert>
              }
              {warningDisplay &&
                <Alert severity="warning">{localStrings.formatString(localStrings.loginError,  warningDisplay)}</Alert>
              }
            </Stack>
          }
          <form onSubmit={formik.handleSubmit}>
            <Box sx={{my: 3}}>
              <Typography
                color="textPrimary"
                variant="h4"
              >
                {localStrings.signIn}
              </Typography>
            </Box>

            {userMail && userMail.endsWith("gmail.com") &&
              <Box sx={{my: 3}}>
                <Typography
                  color="textPrimary"
                  variant="h6"
                >
                  {localStrings.formatString(localStrings.youHaveBeenInvitedGoogle, userMail)}
                </Typography>
              </Box>
            }

            {userMail && !userMail.endsWith("gmail.com") &&
              <Box sx={{my: 3}}>
                <Typography
                  color="textPrimary"
                  variant="h6"
                >
                  {localStrings.formatString(localStrings.youHaveBeenInvitedNoGoogle, userMail)}
                </Typography>
              </Box>
            }
            {/*<p>{userMail}</p>*/}
            {(!userMail || (userMail && userMail.endsWith("gmail.com"))) &&
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                xs={12}
                md={12}
              >
                <LoadingButton
                  color="error"
                  fullWidth
                  onClick={handleGoogleClick}
                  size="large"
                  startIcon={<GoogleIcon/>}
                  loading={logging}
                  variant="contained"
                >
                  {localStrings.loginWithGoogle}
                </LoadingButton>
              </Grid>
            </Grid>
            }
            {(!userMail || (userMail && !userMail.endsWith("gmail.com"))) &&
            <>
              {!userMail &&
              <Box
                sx={{
                  pb: 1,
                  pt: 3
                }}
              >
                <Typography
                  align="center"
                  color="textSecondary"
                  variant="body1"
                >
                  {localStrings.orLoginEmail}

                </Typography>
              </Box>
              }
              <TextField
                error={Boolean(formik.touched.email && formik.errors.email)}
                fullWidth
                helperText={formik.touched.email && formik.errors.email}
                label={localStrings.emailAddress}
                margin="normal"
                name="email"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="email"
                value={formik.values.email}
              />
              <TextField
                error={Boolean(formik.touched.password && formik.errors.password)}
                fullWidth
                helperText={formik.touched.password && formik.errors.password}
                label={localStrings.password}
                margin="normal"
                name="password"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                type="password"
                value={formik.values.password}
              />
              <Box sx={{py: 2}}>
                <LoadingButton
                  color="primary"
                  disabled={formik.isSubmitting}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  loading={logging}
                  loadingPosition="end"
                >
                  {localStrings.signInNow}
                </LoadingButton>
              </Box>
              <Typography
                color="textSecondary"
                variant="body2"
              >
                {localStrings.dontHaveAccount}
                {' '}

                <Link
                  href="/register"
                  variant="subtitle2"
                  underline="hover"
                  sx={{
                    cursor: 'pointer'
                  }}
                >
                  {localStrings.signUpNow}
                </Link>
              </Typography>

              <Typography
                color="textSecondary"
                variant="body2"
              >
                {localStrings.forgotPassword}
                {' '}

                <Link
                  href="/resetPassword"
                  variant="subtitle2"
                  underline="hover"
                  sx={{
                    cursor: 'pointer'
                  }}
                >
                  {localStrings.resetPassword}
                </Link>
              </Typography>
            </>
            }
          </form>
        </Container>
      </Box>

    </div>
  );
};

export default Login;
